import * as types from "./actionTypes";

const initialState = {
  banner: [],
  internalBanner: [],
  category: [],
  trendingGreeting: [],
  trendingInvitation: [],
  greetCards: [],
  invitationCards: [],
  allInvitationsCards: [],
  allGreetingsCards: [],
  sentInvitationsCards: [],
  trendingProducts: [],
  allProductsHome: [],
  allHomeDecor: [],
  allPots: [],
  wishfyFrames: [],
  inspiration: [],
  groupCategory: [],
  getAllCategory: [],
  allGroup: [],
  allOrders: [],
  allSentGreetings: [],
  allReceiveGreeting: [],
  allEvents: [],
  giftedByMe: [],
  banquetHall: [],
  isLoading: false,
  isError: false,
  interest: [],
  filterInspiration: [],
};

const appReducer = (oldState = initialState, actionObj) => {
  const { type, payload } = actionObj;

  switch (type) {
    case types.GET_INTERNAL_BANNER_REQUEST:
      return { ...oldState, isLoading: true };
    case types.GET_INTERNAL_BANNER_SUCCESS:
      return { ...oldState, isLoading: false, internalBanner: payload };
    case types.GET_INTERNAL_BANNER_ERROR:
      return { ...oldState, isLoading: false, isError: true };
    //internal
    case types.GET_BANNER_REQUEST:
      return { ...oldState, isLoading: true };
    case types.GET_BANNER_SUCCESS:
      return { ...oldState, isLoading: false, banner: payload };
    case types.GET_BANNER_ERROR:
      return { ...oldState, isLoading: false, isError: true };
    //events
    case types.GET_MY_EVENTS_REQUEST:
      return { ...oldState, isLoading: true };
    case types.GET_MY_EVENTS_SUCCESS:
      return { ...oldState, isLoading: false, allEvents: payload };
    case types.GET_MY_EVENTS_ERROR:
      return { ...oldState, isLoading: false, isError: true };
    //category
    case types.GET_CATEGORY_REQUEST:
      return { ...oldState, isLoading: true };
    case types.GET_CATEGORY_SUCCESS:
      return { ...oldState, isLoading: false, category: payload };
    case types.GET_CATEGORY_ERROR:
      return { ...oldState, isLoading: false, isError: true };
    //trending greetings
    case types.GET_TRENDING_GREETING_REQUEST:
      return { ...oldState, isLoading: true };
    case types.GET_TRENDING_GREETING_SUCCESS:
      return { ...oldState, isLoading: false, trendingGreeting: payload };
    case types.GET_TRENDING_GREETING_ERROR:
      return { ...oldState, isLoading: false, isError: true };
    //trending Invitations
    case types.GET_TRENDING_INVITATION_REQUEST:
      return { ...oldState, isLoading: true };
    case types.GET_TRENDING_INVITATION_SUCCESS:
      return { ...oldState, isLoading: false, trendingInvitation: payload };
    case types.GET_TRENDING_INVITATION_ERROR:
      return { ...oldState, isLoading: false, isError: true };
    //trending Products
    case types.GET_TRENDING_PRODUCT_REQUEST:
      return { ...oldState, isLoading: true };
    case types.GET_TRENDING_PRODUCT_SUCCESS:
      return { ...oldState, isLoading: false, trendingProducts: payload };
    case types.GET_TRENDING_PRODUCT_ERROR:
      return { ...oldState, isLoading: false, isError: true };
    //All Products
    case types.GET_ALL_PRODUCTS_HOME_REQUEST:
      return { ...oldState, isLoading: true };
    case types.GET_ALL_PRODUCTS_HOME_SUCCESS:
      return { ...oldState, isLoading: false, allProductsHome: payload };
    case types.GET_ALL_PRODUCTS_HOME_ERROR:
      return { ...oldState, isLoading: false, isError: true };
    //All homeDecor
    case types.GET_ALL_HOMEDECOR_REQUEST:
      return { ...oldState, isLoading: true };
    case types.GET_ALL_HOMEDECOR_SUCCESS:
      return { ...oldState, isLoading: false, allHomeDecor: payload };
    case types.GET_ALL_HOMEDECOR_ERROR:
      return { ...oldState, isLoading: false, isError: true };
    //All Pots
    case types.GET_ALL_POTS_REQUEST:
      return { ...oldState, isLoading: true };
    case types.GET_ALL_POTS_SUCCESS:
      return { ...oldState, isLoading: false, allPots: payload };
    case types.GET_ALL_POTS_ERROR:
      return { ...oldState, isLoading: false, isError: true };
    //All wishfy frames
    case types.GET_WISHFY_FRAMES_REQUEST:
      return { ...oldState, isLoading: true };
    case types.GET_WISHFY_FRAMES_SUCCESS:
      return { ...oldState, isLoading: false, wishfyFrames: payload };
    case types.GET_WISHFY_FRAMES_ERROR:
      return { ...oldState, isLoading: false, isError: true };
    //Banquet hall
    case types.GET_BANQUET_HALL_REQUEST:
      return { ...oldState, isLoading: true };
    case types.GET_BANQUET_HALL_SUCCESS:
      return { ...oldState, isLoading: false, banquetHall: payload };
    case types.GET_BANQUET_HALL_ERROR:
      return { ...oldState, isLoading: false, isError: true };
    //All order
    case types.GET_ORDERS_HISTORY_REQUEST:
      return { ...oldState, isLoading: true };
    case types.GET_ORDERS_HISTORY_SUCCESS:
      return { ...oldState, isLoading: false, allOrders: payload };
    case types.GET_ORDERS_HISTORY_ERROR:
      return { ...oldState, isLoading: false, isError: true };

    // get all category
    case types.GET_CATEGORY_DATA_REQUEST:
      return { ...oldState, isLoading: true };
    case types.GET_CATEGORY_DATA_SUCCESS:
      return { ...oldState, isLoading: false, getAllCategory: payload };
    case types.GET_CATEGORY_DATA_ERROR:
      return { ...oldState, isLoading: false, isError: true };
    //All Cards
    case types.GET_GREET_REQUEST:
      return { ...oldState, isLoading: true };
    case types.GET_GREET_SUCCESS:
      return { ...oldState, isLoading: false, greetCards: payload };
    case types.GET_GREET_ERROR:
      return { ...oldState, isLoading: false, isError: true };
    //Invitation
    case types.GET_INVITATION_REQUEST:
      return { ...oldState, isLoading: true };
    case types.GET_INVITATION_SUCCESS:
      return { ...oldState, isLoading: false, invitationCards: payload };
    case types.GET_INVITATION_ERROR:
      return { ...oldState, isLoading: false, isError: true };
    //Inspiration
    case types.GET_INSPIRATION_REQUEST:
      return { ...oldState, isLoading: true };
    case types.GET_INSPIRATION_SUCCESS:
      return { ...oldState, isLoading: false, inspiration: payload };
    case types.GET_INSPIRATION_ERROR:
      return { ...oldState, isLoading: false, isError: true };
    // Filter Inspiration
    case types.FETCH_INSPIRATION_BOARD_REQUEST:
      return {
        ...oldState,
        isLoading: true,
      };
    case types.FETCH_INSPIRATION_BOARD_SUCCESS:
      return {
        ...oldState,
        filterInspiration: payload,
        isLoading: false,
      };
    case types.FETCH_INSPIRATION_BOARD_FAILURE:
      return {
        ...oldState,
        IsError: true,
        isLoading: false,
      };
    //ALL Greet
    case types.GET_ALL_GREETINGS_REQUEST:
      return { ...oldState, isLoading: true };
    case types.GET_ALL_GREETINGS_SUCCESS:
      return { ...oldState, isLoading: false, allGreetingsCards: payload };
    case types.GET_ALL_GREETINGS_ERROR:
      return { ...oldState, isLoading: false, isError: true };
    //ALL Invitation
    case types.GET_ALL_INVITATION_REQUEST:
      return { ...oldState, isLoading: true };
    case types.GET_ALL_INVITATION_SUCCESS:
      return { ...oldState, isLoading: false, allInvitationsCards: payload };
    case types.GET_ALL_INVITATION_ERROR:
      return { ...oldState, isLoading: false, isError: true };
    //sent Invitation
    case types.GET_SENT_INVITATION_REQUEST:
      return { ...oldState, isLoading: true };
    case types.GET_SENT_INVITATION_SUCCESS:
      return { ...oldState, isLoading: false, sentInvitationsCards: payload };
    case types.GET_SENT_INVITATION_ERROR:
      return { ...oldState, isLoading: false, isError: true };
    //all GROPUP CATEGORY
    case types.GET_GROUP_CATEGORY_REQUEST:
      return { ...oldState, isLoading: true };
    case types.GET_GROUP_CATEGORY_SUCCESS:
      return { ...oldState, isLoading: false, groupCategory: payload };
    case types.GET_GROUP_CATEGORY_ERROR:
      return { ...oldState, isLoading: false, isError: true };
    //all GROPUP ALL
    case types.GET_ALL_GROUP_REQUEST:
      return { ...oldState, isLoading: true };
    case types.GET_ALL_GROUP_SUCCESS:
      return { ...oldState, isLoading: false, allGroup: payload };
    case types.GET_ALL_GROUP_ERROR:
      return { ...oldState, isLoading: false, isError: true };
    //all GREETING SENT
    case types.GET_SENT_GREETINGS_REQUEST:
      return { ...oldState, isLoading: true };
    case types.GET_SENT_GREETINGS_SUCCESS:
      return { ...oldState, isLoading: false, allSentGreetings: payload };
    case types.GET_SENT_GREETINGS_ERROR:
      return { ...oldState, isLoading: false, isError: true };
    //all GREETING RECEIVE
    case types.GET_RECEIVE_GREETINGS_REQUEST:
      return { ...oldState, isLoading: true };
    case types.GET_RECEIVE_GREETINGS_SUCCESS:
      return { ...oldState, isLoading: false, allReceiveGreeting: payload };
    case types.GET_RECEIVE_GREETINGS_ERROR:
      return { ...oldState, isLoading: false, isError: true };
    //all Gifted by me
    case types.GET_GIFT_DIARY_REQUEST:
      return { ...oldState, isLoading: true };
    case types.GET_GIFT_DIARY_SUCCESS:
      return { ...oldState, isLoading: false, giftedByMe: payload };
    case types.GET_GIFT_DIARY_ERROR:
      return { ...oldState, isLoading: false, isError: true };
    //all INTEREST
    case types.GET_INTEREST_REQUEST:
      return { ...oldState, isLoading: true };
    case types.GET_INTEREST_SUCCESS:
      return { ...oldState, isLoading: false, interest: payload };
    case types.GET_INTEREST_ERROR:
      return { ...oldState, isLoading: false, isError: true };
    // add groups
    case types.ADD_GROUPS_REQUEST:
      return { ...oldState, isLoading: true };
    case types.ADD_GROUPS_SUCCESS:
      return { ...oldState, isLoading: false };
    case types.ADD_GROUPS_ERROR:
      return { ...oldState, isLoading: false, isError: true };
    // add gIFT dIARY
    case types.ADD_GIFT_DIARY_REQUEST:
      return { ...oldState, isLoading: true };
    case types.ADD_GIFT_DIARY_SUCCESS:
      return { ...oldState, isLoading: false };
    case types.ADD_GIFT_DIARY_ERROR:
      return { ...oldState, isLoading: false, isError: true };
    // add gIFT dIARY
    case types.ADD_IMAGE_REQUEST:
      return { ...oldState, isLoading: true };
    case types.ADD_IMAGE_SUCCESS:
      return { ...oldState, isLoading: false };
    case types.ADD_IMAGE_ERROR:
      return { ...oldState, isLoading: false, isError: true };
    // add send greetings
    case types.SEND_GREETINGS_REQUEST:
      return { ...oldState, isLoading: true };
    case types.SEND_GREETINGS_SUCCESS:
      return { ...oldState, isLoading: false };
    case types.SEND_GREETINGS_ERROR:
      return { ...oldState, isLoading: false, isError: true };

    default:
      return oldState;
  }
};
export { appReducer };
